<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="150 -850 700 700">
    <path
      d="M112.8-111.28v-228.46h179.4l137.89-151.65v-92.63q-38.72-16.48-63.08-50.82-24.36-34.33-24.36-76.53 0-58.2 40.46-98.65 40.46-40.46 98.65-40.46 58.2 0 98.65 40.46 40.46 40.45 40.46 98.65 0 42.2-25.24 76.03-25.24 33.84-64.2 51.32v92.63l137.9 151.65h179.39v228.46h-226.7v-133.46L480-400.76 339.74-244.74v133.46H112.8Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ProfileIcon",
};
</script>
